// extracted by mini-css-extract-plugin
export default {"sec":"Companies_sec__oMCiz","kokoro":"Companies_kokoro__HgP-4","image":"Companies_image__tuE6s"};